// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { all } from 'redux-saga/effects';

import addressValidationSagas from './address';
import countriesSaga from './countries';
import deviceLookUpSagas from './device';
import manageUsersSagas from './manageUsers';
import orderCreationSaga from './orderCreation';
import registerSagas from './registration';
import resetSagas from './reset/startOverSaga';
import selectedShippingOfferSagas from './selectedShippingOffer';
import serviceRequestSagas from './serviceRequest';
import shippingAddressSagas from './shippingAddress';
import shippingOfferSagas from './shippingOffer';
import provincesSagas from './provinces';
import userFeedbackSaga from './feedback';
import userInfoSagas from './userInfo';
import warrantySagas from './warranty';
import attachmentSagas from './attachments';
import managePartnersSagas from './managePartners';
import manageAadOps from './manageAadOps';
import customerServiceLocationAddress from './customerServiceLocationAddress';
import configSagas from './config';

const Sagas = function* () {
    yield all([
        ...addressValidationSagas,
        ...countriesSaga,
        ...deviceLookUpSagas,
        ...manageUsersSagas,
        ...orderCreationSaga,
        ...registerSagas,
        ...resetSagas,
        ...selectedShippingOfferSagas,
        ...serviceRequestSagas,
        ...shippingAddressSagas,
        ...shippingOfferSagas,
        ...provincesSagas,
        ...userFeedbackSaga,
        ...userInfoSagas,
        ...warrantySagas,
        ...attachmentSagas,
        ...managePartnersSagas,
        ...manageAadOps,
        ...customerServiceLocationAddress,
        ...configSagas,
    ]);
};

export default Sagas;
